import { render } from "./XIconSolidFingerprint.vue?vue&type=template&id=bf917ec0"
import script from "./XIconSolidFingerprint.vue?vue&type=script&lang=js"
export * from "./XIconSolidFingerprint.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidFingerprint.vue"]])

export default __exports__